// src/pages/CreatorPromotionsPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import CreatorNav from '../components/CreatorNav';
import CreatorTopMenuBar from '../components/CreatorTopMenuBar';
import CreatorMobileBottomNav from '../components/CreatorMobileBottomNav';
import UniversalFooter from '../components/UniversalFooter';
import { Megaphone, Target, TrendingUp, Calendar } from 'lucide-react';

const CreatorPromotionsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 text-slate-50">
      <CreatorNav />
      <CreatorTopMenuBar />
      
      <div className="pb-20 md:pb-0">
        <div className="container mx-auto px-4 py-8 max-w-7xl">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-4xl font-bold text-white mb-2">
              Promotional Tools
            </h1>
            <p className="text-slate-400">
              Manage campaigns and promotional settings for your NFD-SmartBooks<sup className="text-[0.6em]">™</sup>
            </p>
          </div>

          {/* Coming Soon Card */}
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 rounded-2xl border border-slate-700 p-12 text-center">
              <div className="flex justify-center mb-6">
                <div className="w-20 h-20 bg-purple-600/20 rounded-full flex items-center justify-center">
                  <Megaphone className="w-10 h-10 text-purple-400" />
                </div>
              </div>
              
              <h2 className="text-3xl font-bold text-white mb-4">
                Promotional Tools Coming Soon
              </h2>
              
              <p className="text-lg text-slate-300 mb-8 max-w-2xl mx-auto">
                We're building powerful promotional features to help you reach more readers and grow your audience.
              </p>

              {/* Feature Preview Grid */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                <div className="bg-slate-800/50 rounded-lg p-6 text-left">
                  <Target className="w-8 h-8 text-blue-400 mb-3" />
                  <h3 className="font-semibold text-white mb-2">Targeted Campaigns</h3>
                  <p className="text-sm text-slate-400">
                    Create and manage promotional campaigns for specific audiences
                  </p>
                </div>

                <div className="bg-slate-800/50 rounded-lg p-6 text-left">
                  <TrendingUp className="w-8 h-8 text-green-400 mb-3" />
                  <h3 className="font-semibold text-white mb-2">Performance Tracking</h3>
                  <p className="text-sm text-slate-400">
                    Monitor campaign performance and engagement metrics
                  </p>
                </div>

                <div className="bg-slate-800/50 rounded-lg p-6 text-left">
                  <Calendar className="w-8 h-8 text-purple-400 mb-3" />
                  <h3 className="font-semibold text-white mb-2">Schedule & Automate</h3>
                  <p className="text-sm text-slate-400">
                    Set up automated promotional activities and schedules
                  </p>
                </div>
              </div>

              <button
                onClick={() => navigate('/author')}
                className="px-6 py-3 bg-purple-600 hover:bg-purple-700 rounded-lg font-medium transition-colors"
              >
                Back to Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>

      <CreatorMobileBottomNav />
      <UniversalFooter />
    </div>
  );
};

export default CreatorPromotionsPage;
